import { CHANNELS_HAS_ERRORED, CHANNELS_IS_LOADING, CHANNELS_DATA_SUCCESS } from './types';
import { globalFetch } from './globalActions';
import { FEED_URLSRC_CMS_V2 } from '../constants';

///////////
// Channel Feed //
///////////

export function channelsFetchDataSuccess(items) {
	return {
		type: CHANNELS_DATA_SUCCESS,
		payload: items.results
	};
}

export function channelsFetchData() {
	return globalFetch({
		urlPath: "channels",
		urlSrc: FEED_URLSRC_CMS_V2,
		reducerIsLoading: CHANNELS_IS_LOADING,
		reducerError: CHANNELS_HAS_ERRORED,
		dispatchSuccess: (itemObj, dispatch) => {
			dispatch(channelsFetchDataSuccess(itemObj));
		}
	});
}
